import * as React from "react";
import * as classnames from "classnames";
import {isFunction} from "lodash";
import {WrappedFieldProps} from "redux-form";

import StyleProps from "../../../../../../shared/ts/interfaces/style";
import {Store} from "../../../../project/reducer";
import FieldLabel from "../../FieldLabel";
import FieldError from "../../FieldError";

interface TextareaFieldProps extends StyleProps, WrappedFieldProps<Store> {
    error?: string;
    type?: string;
    label?: string;
    placeholder?: string;
    onValueUpdate?: (name: string) => void;
    groupClassName?: string;
    maxLength?: number;
}

interface TextareaFieldState {
    latestUpdateValue: string;
}

export default class InputField extends React.Component<TextareaFieldProps, TextareaFieldState> {

    constructor(props: TextareaFieldProps) {
        super(props);
        this.state = {latestUpdateValue: props.input.value};
    }

    protected onFocus = (e: React.MouseEvent) => {
        this.setState({latestUpdateValue: this.props.input.value});
    };

    private onBlur = (e: React.MouseEvent) => {
        const {input} = this.props;
        input.onBlur(e);
        if (isFunction(this.props.onValueUpdate)) {
            // call only when value has changed
            if (this.state.latestUpdateValue !== input.value) {
                this.props.onValueUpdate(input.name);
            }
        }
    };

    public render(): JSX.Element {
        const {error, input, label, type, placeholder, className, groupClassName, maxLength} = this.props;
        const holderClassName = classnames("form-group", groupClassName, error && "has-error");
        const fieldClassName = classnames("form-control", className);

        // Field
        // `value` attribute issue: https://github.com/erikras/redux-form/issues/720
        const field = (
            <textarea {...input}
                id={input.name}
                value={input.value || ""}
                className={`${fieldClassName} form-control`}
                placeholder={placeholder}
                maxLength={maxLength}
                type={type}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
            />
        );

        return (
            <div className={holderClassName}>
                {label && <FieldLabel label={label} htmlFor={input.name}/>}
                {error ? <FieldError error={error}>{field}</FieldError> : field}
            </div>
        );
    }
}
